import gql from 'graphql-tag';

// Action Types
export const GET_DOCUMENT_VERIFICATIONS_START = 'GET_DOCUMENT_VERIFICATIONS_START';
export const GET_DOCUMENT_VERIFICATIONS_SUCCESS = 'GET_DOCUMENT_VERIFICATIONS_SUCCESS';
export const GET_DOCUMENT_VERIFICATIONS_ERROR = 'GET_DOCUMENT_VERIFICATIONS_ERROR';

// GraphQL Query
export const GET_DOCUMENT_VERIFICATIONS_QUERY = gql`
  query GetDocumentVerifications($userId: String!) {
    getDocumentVerifications(userId: $userId) {
      id
      userId
      fileName
      fileType
      documentType
      documentStatus
      createdAt
      updatedAt
    }
  }
`;

// Action Creator
export const getDocumentVerifications = (userId) => async (dispatch) => {
  dispatch({ type: GET_DOCUMENT_VERIFICATIONS_START });

  try {
    const response = await fetch('/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        query: `
          query GetDocumentVerifications($userId: String!) {
            getDocumentVerifications(userId: $userId) {
              id
              userId
              fileName
              fileType
              documentType
              documentStatus
              createdAt
              updatedAt
            }
          }
        `,
        variables: { userId },
      }),
    });

    const result = await response.json();
   
    if (result.errors) {
      throw new Error(result.errors[0].message);
    }

    const verifications = result.data?.getDocumentVerifications;

    if (Array.isArray(verifications) && verifications.length > 0) {
      const passportApproved = verifications.some(
        doc => doc.documentType === 'passport' && doc.documentStatus === 'approved'
      );

      const licenceApproved = verifications.some(
        doc => doc.documentType === 'licence' && doc.documentStatus === 'approved'
      );

      if (passportApproved && licenceApproved) {
        dispatch({
          type: GET_DOCUMENT_VERIFICATIONS_SUCCESS,
          payload: {
            status: 'approved',
            message: 'All required documents are approved.',
            data: verifications
          },
        });
        return 'accept';
      } else {
        dispatch({
          type: GET_DOCUMENT_VERIFICATIONS_ERROR,
          payload: {
            error: 'Required documents are not approved.',
            status: 'rejected',
            data: verifications
          },
        });
        return 'reject';
      }
    } else {
      dispatch({
        type: GET_DOCUMENT_VERIFICATIONS_ERROR,
        payload: {
          error: 'No verification documents found.',
          status: 'not_found',
        },
      });
      return null;
    }
  } catch (error) {
    console.error('Error fetching document verifications:', error);
    dispatch({
      type: GET_DOCUMENT_VERIFICATIONS_ERROR,
      payload: {
        error: error.message || 'Failed to fetch document verifications.',
      },
    });
  }
};
